/*
 * Public API Surface of initial-page
 */

export * from './pages/initial-page.component';
export * from './lib/initial-page.module';
